import { render, staticRenderFns } from "./editSegment.vue?vue&type=template&id=50a64e28&lang=pug"
import script from "./editSegment.vue?vue&type=script&lang=js"
export * from "./editSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports